module.exports = __webpack_public_path__ + "img/shift-option.6436b18b.png";